import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Slider from '@mui/material/Slider';
import Input from '@mui/material/Input';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const styles = {
    container: {
      width: '60%', // Adjust the width of the Autocomplete component
    },
    title: {
        fontFamily: 'Roboto Light',
        fontSize: 12,
      },
    input: {
      fontFamily: 'Roboto', // Set font to Roboto Slab
      fontSize: 12, // Set font size to 14 (or adjust as needed)
    },

  };


export interface InputSliderProps {
  title: string
  onChange: (axisType:string) => void;
  team_df: any[]
}

const SliderSelector: React.FC<InputSliderProps> = ({
  title,
  onChange,
  team_df
}) => {

  const [value, setValue] =  React.useState<string>(
  );



    var team_list =   Array.from(new Set(team_df.map((data : any) => data["team_consolidated"]))).sort();
    team_list =   team_list.slice(0, team_list.length - 1);



  const handleSelectChange = (event: any, newValue: any ) => {

    console.log("Setting New Value:")
    console.log(newValue)


    if (newValue.length > 2) {
      
      newValue.shift(); 
    }

    setValue(newValue);
    onChange(newValue)
  };


  return (
    <Box sx={styles.container}>
      <Typography id="input-slider"  gutterBottom variant="body1" sx={styles.title} >
        {title}
      </Typography>
      <Autocomplete
      multiple
      disablePortal
      onChange={handleSelectChange}
      id="combo-box-demo"
      options={team_df}
      getOptionLabel={(option) => option.team_consolidated}
      sx={{
        '& .MuiInputBase-input': styles.input, // Apply custom styles to the input field
      }}
      renderOption={(props, option) => (
        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
          <img
            width="20"
            srcSet={option.team_logo}
            src={option.team_logo}
            alt=""
          />
          {option.team_consolidated} 
        </Box>
      )}

      renderInput={(params) => 
      <TextField 
        {...params} 
        label="Select Team" 
        variant="outlined"
        inputProps={{ ...params.inputProps, style: { fontSize: 10 } }}

        />}
    />
    </Box>
  );
}

export default SliderSelector;
